import CommonTable from './CommonTable/index.vue'
import FormTable from './FormTable/index.vue'
import WidgetItem from './WidgetItem/index.vue'
import MDialog from './MDialog/index.vue'
import Column from './CommonTable/Column.vue'
import SearchForm from './SearchForm/index.vue'
import FormItem from './FormTable/FormItem.vue'
import MPopper from './MPopper/index.vue'
import ButtomBtns from './ButtomBtns/index.vue'
import TableColumnOptionBtn from './TableColumnOptionBtn/index.vue'
import RowWarpPopper from './RowWarpPopper/index.vue'
import MPreview from './MPreview/index.vue'

import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig'

import { App } from 'vue'

const components = [CommonTable, FormTable, WidgetItem, MDialog, Column, SearchForm, FormItem, MPopper, ButtomBtns, MPreview, TableColumnOptionBtn, RowWarpPopper]

const install = function (Vue: App) {
  components.forEach(com => {
    Vue.component(com.name, com)
  })
}


export default {
  install,
  usePageConfig,
  useTableOptions
}